exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".users-container {\n    border: 1px solid #efd2d2;\n    border-top: transparent;\n    background: #fefefe;\n    padding: 10px 15px;\n    color: #555;\n    font-size: 1.2em;\n}\n.user-container__block p {\n    margin: 0;\n}\n.users-container:first-child {\n    border-top: 1px solid #efd2d2;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n}\n.users-container:last-child {\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n}\n.user-container__field-name {\n    display: inline-block;\n    margin-right: 5px;\n    color: #555;\n    font-weight: bold;\n}\n.user-container__field-name::after {\n    content: ':';\n    display: block;\n    float: right;\n}\n.user-container__field-value {\n    color: #555;\n}\n.active-user {\n    font-weight: bold;\n    color: #8ac440;\n}\n.inactive-user {\n    font-weight: bold;\n    color: #d11;\n}\n@media screen and (max-width: 767px) {\n    .user-container__field-name {\n        width: 100%;\n    }\n    .user-container__field-name::after {\n        display: none;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/users/users/users.component.css
// module id = ../../../../../angular/app/components/users/users/users.component.css
// module chunks = 1